import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationLT from "./locales/lt/translation.json";
import translationRU from "./locales/ru/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      lt: { translation: translationLT },
      ru: { translation: translationRU },
    },
    fallbackLng: "lt",
    detection: {
      order: ["cookie", "querystring", "localStorage", "navigator", "htmlTag"],
      caches: ["cookie"], // store language choice in cookie
      cookieMinutes: 525600, // one year
      lookupCookie: "lang", // name of the cookie to check
    },
    interpolation: {
      escapeValue: false,
    },
    load: "languageOnly",
  })
  .then(() => {
    const lng = i18n.language;
    if (lng && lng.startsWith("en")) {
      i18n.changeLanguage("en"); // 👈 force normalize
    }
  });

export default i18n;
